<template>
  <v-container
    fluid
    class="
      ma-0
      pa-0
      text-caption
      text-sm-subtitle-1
      text-md-subtitle-1
      text-lg-subtitle-1
      text-xl-subtitle-1
    "
  >
    <v-row>
      <v-col class="py-0">
        <span class="font-weight-bold primary--text"
          >Análisis {{ getType(tracing.type) }}</span
        >
      </v-col>
      <v-col class="text-end d-flex justify-end align-center py-0">
        <span class="primary--text mr-2"
          >{{ tracing.analysis.type ? tracing.analysis.analysis.length : 0 }}/{{
            tracing.baseTotal
          }}</span
        >
        <v-img
          max-width="16"
          max-height="16"
          :src="require('@/assets/img/flag_target.png')"
        ></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" class="py-0 pr-1">
        <span class="font-weight-bold primary--text"> Folio </span>
      </v-col>
      <v-col class="py-0 px-1">
        <span class="font-weight-bold primary--text"> Muestra </span>
      </v-col>
      <v-col class="py-0 px-1">
        <span class="font-weight-bold primary--text"> Zona de muestreo </span>
      </v-col>
    </v-row>
    <v-row
      v-for="(sample, indexSample) of tracing.analysis.analysis"
      :key="indexSample + Math.random()"
    >
      <v-col cols="2" class="py-3 pr-1">
        <span class="font-weight-bold">
          {{ sample.folioAnalysis }}
        </span>
      </v-col>
      <v-col class="py-3 px-1">
        <span v-if="sample.folioAnalysis != '--'">
          {{ getFormatted(sample.date) }}
        </span>
        <span v-else>
          {{ sample.date }}
        </span>
      </v-col>
      <v-col class="py-3 px-1">
        <span class="font-weight-bold">
          {{ getName(sample.name) }}
        </span>
      </v-col>
    </v-row>

    <v-row
      v-for="(application, indexApp) of tracing.applications"
      :key="indexApp + Math.random()"
    >
      <v-col class="py-3">
        <span class="font-weight-bold primary--text"
          >Mes {{ application.month }} - Semana {{ application.week }}
        </span>
        <v-row
          v-for="(dose, indexDose) of application.doses"
          :key="indexDose + Math.random()"
          class="mt-2"
        >
          <v-col class="py-0">
            <span
              >{{ dose.dose }} dósis de {{ dose.strain.name
              }}{{ dose.strain.bioactiveBank ? "*Solena" : "*Nativa" }}</span
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  props: {
    tracing: Object,
    required: true,
  },
  data: () => ({}),
  methods: {
    getType(value) {
      let types = {
        INITIAL: "Inicial",
        MONITORING: "Seguimiento",
      };
      return types[value];
    },
    getFormatted(date) {
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    getName(value) {
      if (value.length <= 16) {
        return value;
      } else {
        return this.truncateString(value, 16);
      }
    },
    truncateString(str, num) {
      // If the length of str is less than or equal to num
      // just return str--don't truncate it.
      if (str.length <= num) {
        return str;
      }
      // Return str truncated with '...' concatenated to the end of str.
      return str.slice(0, num) + "...";
    },
  },
};
</script>